module.exports = __webpack_public_path__ + "static/quem-somos-xl-5c6aec2c4eeb37c1d0e4117cefce9d83.png";